// Smart number formatting utility
// For values >= 1, if the fractional part is less than 0.01% of the value, round to integer; otherwise, keep 2 decimals.
// For values < 1, keep up to 6 decimals, trimming trailing zeros.

export function formatSmartNumber(val) {
  if (val === '' || val === null || isNaN(val)) return '';
  const num = Number(val);
  if (num === 0) return '0';
  if (Math.abs(num) >= 1) {
    const frac = Math.abs(num - Math.round(num));
    // If fractional part is less than 0.01% of the value, round to integer
    if (frac < Math.abs(num) * 0.0001) {
      return Math.round(num).toString();
    }
    // Keep 2 decimals, no thousands separator
    return num.toFixed(2).replace(/\.00$/, '');
  } else {
    // For numbers < 1, show up to 6 decimals, trim trailing zeros
    return num.toFixed(6).replace(/(?:\.\d*?[1-9])0+$/,'').replace(/\.0+$/,'');
  }
} 